import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyConverter'
})
export class CurrencyConverterPipe implements PipeTransform {
  transform(
    value: any,
    fromCurrency: string,
    toCurrency: string,
    currencies: any[]
  ): number | string {
    if (!value || !fromCurrency || !toCurrency || !currencies?.length) {
      return value;
    }
    value = Number(value);
    // Encontrar las tasas de conversión
    const fromRateObj = currencies.find(c => c.code === fromCurrency);
    const toRateObj = currencies.find(c => c.code === toCurrency);

    if (!fromRateObj || !toRateObj) {
      return value;
    }

    // Convertir a USD primero (si no es USD)
    const fromRate = parseFloat(fromRateObj.rate);
    const toRate = parseFloat(toRateObj.rate);

    // Fórmula: (Valor / TasaOrigen) * TasaDestino
    const convertedValue = (value / fromRate) * toRate;

    return convertedValue.toFixed(2);
  }
}
